import { axios } from "common";

export const apiPlantList = ({ mappId }) => {
  return axios.get("/plant/nlist", { params: { mappId } });
};
